
import React, { useEffect } from "react";
import { Field } from "redux-form";
import { renderField } from "../../Utils/renderField";
import { SelectField } from "../../Utils/renderField/renderField";
import { GENDER } from "../../../../utility/constants";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const renderPacients = ({
    fields,
    meta: { touched, error, submitFailed },
    vehicles,
    isView,
}) => {
    useEffect(() => {
        fields.push({});
    }, []);

    return (
        <React.Fragment>
            <div className="col-12 col-md-6 form-group d-flex align-items-end">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => fields.push({})}
                >
                    Agregar Paciente
                </button>
            </div>
            <div
                className="col-12 form-group"
                style={{ minHeight: `${fields.length * 50 + 150}px` }}
            >
                {fields.length > 0 ? (
                    <React.Fragment>
                        {/* Desktop View (Table) */}
                        <div className="d-none d-md-block table-responsive">
                            <Table className="table">
                                <Thead>
                                    <Tr className="table-primary text-white">
                                        <Th>#</Th>
                                        <Th>Nombre <span className="text-danger">*</span></Th>
                                        <Th style={{ width: '100px' }}>Edad <span className="text-danger">*</span></Th>
                                        <Th>Dirección <span className="text-danger">*</span></Th>
                                        <Th style={{ width: '150px' }}>Sexo <span className="text-danger">*</span></Th>
                                        <Th>Se trasladó a <span className="text-danger">*</span></Th>
                                        <Th>Acciones</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {fields.map((member, index) => (
                                        <Tr key={index}>
                                            <Td>{index + 1}</Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.name`}
                                                    placeholder="Nombre"
                                                    type="text"
                                                    disabled={isView}
                                                    component={renderField}
                                                />
                                            </Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.age`}
                                                    placeholder="Edad"
                                                    type="number"
                                                    disabled={isView}
                                                    component={renderField}
                                                />
                                            </Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.address`}
                                                    placeholder="Dirección"
                                                    type="text"
                                                    disabled={isView}
                                                    component={renderField}
                                                />
                                            </Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.genre`}
                                                    placeholder="Sexo"
                                                    disabled={isView}
                                                    options={GENDER}
                                                    component={SelectField}
                                                    className="form-control"
                                                />
                                            </Td>
                                            <Td>
                                                <Field
                                                    name={`${member}.moved_to`}
                                                    placeholder="Se trasladó a"
                                                    type="text"
                                                    disabled={isView}
                                                    component={renderField}
                                                />
                                            </Td>
                                            <Td>
                                                {!isView && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-remove-custom"
                                                        onClick={() => fields.remove(index)}
                                                    >
                                                        <span className="material-icons">close</span>
                                                    </button>
                                                )}
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </div>

                        {/* Mobile View (Cards) */}
                        <div className="d-md-none vehicle-card-container">
                            {fields.map((member, index) => (
                                <div key={index} className="vehicle-card">
                                    <span className="vehicle-card-header">{index + 1}</span>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Nombre <span className="text-danger">*</span></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.name`}
                                                placeholder="Nombre"
                                                type="text"
                                                disabled={isView}
                                                component={renderField}
                                            />
                                        </div>
                                    </div>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Edad <span className="text-danger">*</span></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.age`}
                                                placeholder="Edad"
                                                type="number"
                                                disabled={isView}
                                                component={renderField}
                                            />
                                        </div>
                                    </div>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Dirección <span className="text-danger">*</span></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.address`}
                                                placeholder="Dirección"
                                                type="text"
                                                disabled={isView}
                                                component={renderField}
                                            />
                                        </div>
                                    </div>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Sexo <span className="text-danger">*</span></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.genre`}
                                                placeholder="Sexo"
                                                disabled={isView}
                                                options={GENDER}
                                                component={SelectField}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="vehicle-field-row">
                                        <label className="vehicle-field-label">Se trasladó a <span className="text-danger">*</span></label>
                                        <div className="vehicle-field-value">
                                            <Field
                                                name={`${member}.moved_to`}
                                                placeholder="Se trasladó a"
                                                type="text"
                                                disabled={isView}
                                                component={renderField}
                                            />
                                        </div>
                                    </div>

                                    {!isView && (
                                        <div className="vehicle-field-row">
                                            <label className="vehicle-field-label">Acciones</label>
                                            <div className="vehicle-field-value">
                                                <button
                                                    type="button"
                                                    className="btn btn-remove-custom"
                                                    onClick={() => fields.remove(index)}
                                                >
                                                    <span className="material-icons">close</span>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </React.Fragment>
                ) : (
                    <p>Presione el botón 'Agregar Paciente'.</p>
                )}
            </div>
        </React.Fragment>
    );
};

export default renderPacients;
